import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { PickupService } from '@checkout/feature';
import { ModalService } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'sd-pickup-user-shop-list-modal',
  templateUrl: './pickup-user-shop-list-modal.component.html',
  styleUrls: ['./pickup-user-shop-list-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupUserShopListModalComponent implements OnInit, OnDestroy {
  protected subscription = new Subscription();

  constructor(
    private pickupService: PickupService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.pickupService.setShopEvent.pipe(delay(50)).subscribe(() => {
        this.modalService.closeActiveModal();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
